import {
  isCreditCardOption,
  PaymentMethodFormKind,
  resolvePaymentMethodForm,
  type PaymentOption,
} from '@src/domains/payments';
import type { DefaultMessagesKeys } from '@src/i18n/useTranslate';

type CardFormVisibilityInput = {
  paymentOption: PaymentOption | undefined;
  isForeign: boolean;
};

export type CardFormVisibility = {
  showHolderIdentity: boolean;
  showInstallments: boolean;
  showBillingAddress: boolean;
  showForeignAlert: boolean;
  zipCodeLabel: DefaultMessagesKeys;
  zipCodeMask: 'br_postal_code' | undefined;
  securityCodeSpan: 'full' | undefined;
};

export const resolveCardFormVisibility = ({
  paymentOption,
  isForeign,
}: CardFormVisibilityInput): CardFormVisibility => {
  const isCardMethod = resolvePaymentMethodForm(paymentOption?.paymentMethod.code) === PaymentMethodFormKind.Card;

  return {
    showHolderIdentity: !isForeign,
    showInstallments: isCreditCardOption(paymentOption) && (paymentOption?.installmentOptions?.length ?? 0) > 0,
    showBillingAddress: Boolean(paymentOption?.requiresExternalAuthentication),
    showForeignAlert: isForeign && isCardMethod,
    zipCodeLabel: isForeign ? 'checkout_payment_card_postal_code' : 'checkout_payment_card_zip_code',
    zipCodeMask: isForeign ? undefined : 'br_postal_code',
    securityCodeSpan: isForeign ? 'full' : undefined,
  };
};
